import {React, joinUrl, _n} from 'pexui';
import {showInNewWindow} from './win';
import * as utils from '../../utilities/utils';
import {trackClick} from '../../utilities/track';
import { FaqHelpPage } from './FaqHelpPage';

//questionsPanel:   this is the list of question links that will show up when the user clicks on a topic from the list
//topic:  an item in the list that is mapped to a set of questions and answers

export var faqList = [];
export var questionsPanelCache = [];
export var questionAnswers = [];

export const FaqHelpLink = ({id, className, style}) => {
    // external FAQ link support is added for eapply
    const externalFaqLink = _n('link_help.link');
    if (externalFaqLink) {
        // simple external Faq link
        return <a id={id} className={className}
              style={style}
              href={externalFaqLink}
              onClick={evt=>{trackClick("Click_HelpFAQ")}}
              target="_blank">
              {_n("link_help.label")}
            </a>;
    } else {
        // built-in Faq
        const stylesheets = [
            joinUrl(utils.getBaseUri(), 'infowidget/styles/dls-widget.min.css'),
            joinUrl(utils.getBaseUri(), 'infowidget/styles/pex_getinfo_widget.css'),
            ];
        const onStart = (evt) => {
            evt.preventDefault();

            trackClick("Click_HelpFAQ");
            showInNewWindow(FaqHelpPage, null, {
                title: 'FAQ',
                stylesheets: stylesheets
            });
        };
        const helpContentUrl = utils.getUrlFromResource('link_help.content')

        return <a id={id} 
                className={className}
                style={style}
                href={helpContentUrl}
                onClick={onStart}>
                {_n("link_help.label")}
            </a>;
    }
};



// WEBPACK FOOTER //
// ./application/src/views/comps/faq.jsx